/* eslint no-dupe-keys: "off" */
const styles = {
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
    },
    "25%": {
      transform: "scale(1.3)",
    },
    "50%": {
      transform: "scale(1)",
    },
    "75%": {
      transform: "scale(1.3)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
  imgContainer: {
    overflow: "hidden",
    width: "100%",
    position: "relative",
    cursor: "pointer",
    transition: "color 250ms",
    color: "#9B9B9B",
    padding: 0,
    display: "block",
    fontFamily: ({ theme }) => theme.fontFamily,
    "&:focus": {
      border: "solid rgb(8, 95, 229)",
    },
  },
  image: {
    cursor: "pointer",
    transition: "transform 250ms",
    width: "100%",
    height: "170px",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
  },
  imgHover: {
    transform: "scale(1.4)",
  },
  overlay: {
    transition: `background 250ms, color 250ms`,
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(8, 19, 30, 0.8)",
  },
  overlayHover: {
    backgroundColor: "rgba(8, 19, 30, 0.4)",
  },
  text: {
    boxSizing: "border-box",
    position: "absolute",
    width: "100%",
    padding: "0 32px",
    textAlign: "left",
    transform: "translateY(-50%)",
    top: "50%",
    fontWeight: 300,
    fontSize: "18px",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
    userSelect: "none",
    color: "rgba(180, 180, 180, 1)",
  },
  textHover: {
    color: "#fff",
  },
  marker: {
    position: "absolute",
    right: "2.4em",
    top: "1.4em",
    "& > svg": {
      width: "18px",
      height: "18px",
    },
  },
  checker: {
    display: "block",
    width: "0.2em",
    height: "0.425em",
    borderBottom: "1px solid #fff",
    borderRight: "1px solid #fff",
    position: "absolute",
    left: "0.125em",
    top: "-0.1em",
  },
  selected: {
    borderLeft: "orange 6px solid",
  },
  button: {
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    borderTop: "none",
    borderBottom: "none",
    borderRight: "none",
    cursor: "pointer",
    color: "rgba(99, 115, 164, 0.5)",
    "&:focus": {
      outline: "none",
    },
  },
  imgContainerUnselected: { borderLeft: "#161A24 0px solid" },
  badgeContainer: {
    position: "absolute",
    height: "26px",
    width: "32px",
    borderRadius: "15px",
    top: "1.2em",
    left: "1.3em",
    position: "absolute",
    height: "26px",
    width: "32px",
    borderRadius: "15px",
    top: "1.2em",
    left: "1.3em",
    zIndex: 3,
    backgroundColor: ({ hover }) => `rgba(255, 174, 0, ${hover ? 1 : 0.7})`,
    animation: ({ openCount }) => (openCount === 1 ? "$pulse 3s" : "none"),
  },
  badgeStars: {
    position: "relative",
    top: "2px",
    filter: "brightness(0)",
    transform: "scale(1.1)",
  },
  // Portrait
  "@media (max-width: 1200px)": {
    imgContainer: {
      maxWidth: 330,
      width: "100%",
      height: 200,
      margin: "0 auto",
      marginBottom: 16,
      borderRadius: 4,
    },
    imgContainerUnselected: {
      maxWidth: 330,
      width: "100%",
    },
    image: {
      height: 200,
    },
    overlay: {
      transition: "unset",
      backgroundColor: "unset",
      "&:hover": {
        backgroundColor: "unset",
      },
      display: "none",
    },
    marker: {
      right: "0.8em",
      top: "0.9em",
      "& > svg": {
        width: "18px",
        height: "18px",
      },
    },
    text: {
      padding: "0 32px",
      color: "#fff",
      height: "auto",
      position: "absolute",
      transform: "none",
      margin: "0",
      top: "inherit",
      bottom: "18px",
    },
  },
};

export default styles;
